module.exports = __webpack_public_path__ + "static/img/login_07.337d274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_07.png
// module id = 3JrI
// module chunks = 33